import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_DESCRIPTION = 'Professional psychological services for children and adults in Spencer, West Virginia.';

const pages = {
  '/': ['Psych Services of Roane County | Spencer, WV', DEFAULT_DESCRIPTION],
  '/services': ['Psychological Services | Psych Services of Roane County', 'Explore psychological evaluations, individual therapy, family counseling, and testing services in Spencer, West Virginia.'],
  '/about': ['About Our Practice | Psych Services of Roane County', 'Learn about Psych Services of Roane County and licensed psychologist Janice Blake, M.A.'],
  '/forms': ['Client Forms | Psych Services of Roane County', 'Complete the appropriate adult or child intake forms before your appointment.'],
  '/contact': ['Contact Us | Psych Services of Roane County', 'Call, email, or find Psych Services of Roane County at 315 Market Street in Spencer, West Virginia.'],
};

const setMeta = (selector, attribute, value) => {
  const element = document.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

const RouteMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isPrivateForm = pathname.startsWith('/forms/');
    const [title, description] = pages[pathname] || [
      isPrivateForm ? 'Secure Client Form | Psych Services of Roane County' : pages['/'][0],
      isPrivateForm ? 'Client intake form for Psych Services of Roane County.' : DEFAULT_DESCRIPTION,
    ];
    const canonical = `https://psych-services-wv.com${isPrivateForm ? '/forms' : pathname}`;

    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('link[rel="canonical"]', 'href', canonical);
  }, [pathname]);

  return null;
};

export default RouteMeta;
